import { mapKeysToCamelCase } from '@skytech/utils'

import { API_ROUTE_ADMIN_REPORTS } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { ReportFilters } from './types'

const IS_NEW_BACKEND_API = true

type NewNumberOrdersReportOriginal = {
  id: number
  sim_name: string
  activation_date: string
  email: string
  contact_number: string
  phone_no: string
  employee_number: string
  subscription_service_orders: {
    id: number
    comment: string
    subscription_service: {
      id: number
      name: string
    }
  }
  department: {
    id: number
    name: string
    code: string
  }
  salary_deduction_profile?: {
    id: number
    name: string
  }
  device_policy?: {
    id: number
    name: string
  }
}

export const getNewNumberOrdersReports = async ({
  selectedReportType,
  toDate,
  fromDate,
  isGlobal,
  selectedCustomer,
}: ReportFilters) => {
  if (!fromDate || !toDate) throw Error('Missing date range filters!')

  const searchParams = new URLSearchParams()
  searchParams.append('fromDate', fromDate)
  searchParams.append('toDate', toDate)
  searchParams.append('isGlobal', isGlobal.toString())
  searchParams.append('customerId', String(selectedCustomer || ''))

  const reports = await get<NewNumberOrdersReportOriginal[]>(
    `${API_ROUTE_ADMIN_REPORTS}/${selectedReportType}?${searchParams.toString()}`,
    IS_NEW_BACKEND_API
  )

  return mapKeysToCamelCase(reports)
}
